import { Modal, ModalFooter } from '@/components/common';
import { RfidTagListItem } from '@/models';
import React from 'react';

export interface RfidTagDeactivateConfirmModalProps {
  isOpen: boolean;
  tag: RfidTagListItem | null;
  isSaving: boolean;
  onConfirm: () => void;
  onClose: () => void;
}

export const RfidTagDeactivateConfirmModal: React.FC<RfidTagDeactivateConfirmModalProps> = ({
  isOpen,
  tag,
  isSaving,
  onConfirm,
  onClose,
}) => {
  const assignedEmail = tag?.user?.email ?? null;

  return (
    <Modal
      isOpen={isOpen}
      onClose={onClose}
      closeOnBackdropClick={false}
      title="Disable RFID card"
      footer={
        <ModalFooter
          onCancel={onClose}
          onConfirm={onConfirm}
          confirmText="Disable"
          confirmVariant="danger"
          isLoading={isSaving}
        />
      }
    >
      <p>
        Disable card <strong>{tag?.serialNumber}</strong>?
      </p>
      {tag?.assignment && assignedEmail && (
        <p className="text-muted mb-0">
          This will revoke its current assignment (<code>{assignedEmail}</code>). The user must be
          reassigned manually if the card is reactivated.
        </p>
      )}
    </Modal>
  );
};

export default RfidTagDeactivateConfirmModal;
